import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { IGlobalStoreState } from '../../store';
import { Button } from '../UI/button';

export const PaynKolayForm: FC = () => {
  const paymentRedirectUrl = useSelector(
    (state: IGlobalStoreState) => state.checkout?.process?.paymentRedirectUrl
  );

  if (!paymentRedirectUrl) {
    return null;
  }

  return (
    <div style={{ margin: 'auto', padding: 24, textAlign: 'center' }}>
      <p style={{ marginBottom: 12 }}>
        After clicking the button, you will be redirected to the payment website. Once the payment is completed, you
        will be redirected back.
      </p>
      <Button type="button" onClick={() => (window.location.href = paymentRedirectUrl)}>
        Go to payment
      </Button>
    </div>
  );
};
